<div class="container">
    <mat-dialog-title class="title-block">
        <h2>MOVE SHOW</h2>
        <app-close-x-icon (click)="onClose()"></app-close-x-icon>
    </mat-dialog-title>

    <mat-dialog-content class="content-block">

        <div class="show-name-container">
            <div class="show-name-block">
                <span id="show-label">SHOW NAME:</span>

                <span id="show-name">
                    {{show.name}}
                </span>
            </div>
        </div>

        <div class="available-partners">
            <h4 class="partners-label">PARTNERS</h4>
            <div class="partner-row" *ngFor="let partner of partnerOptions">
                <section class="">
                    <mat-radio-group [(ngModel)]="selectedPartnerId">
                        <mat-radio-button [value]="partner.id">{{ partner.name }}</mat-radio-button>
                    </mat-radio-group>
                </section>
            </div>
        </div>

    </mat-dialog-content>

    <mat-dialog-actions class="action-block">
        <button class="move-show-btn" mat-button (click)="moveShow()">MOVE SHOW</button>
        <button class="cancel-btn" mat-button (click)="onClose()">CANCEL</button>
    </mat-dialog-actions>
</div>